import React, { useState } from "react";
import { ethers } from "ethers";

// Base Mainnet chainId: 8453
export default function BuyShibConisButton({ children }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const CONTRACT_ADDRESS = "0xBA448aD213ADC0a9ff434374ACC3992758960d5c";
  const ABI = [
    "function buyTokens() payable"
  ];
  const TOKEN_PRICE_ETH = 0.0012;
  const BASE_CHAIN_ID = "0x2105"; // 8453 in hex

  async function handleBuy() {
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      if (!window.ethereum) throw new Error("No crypto wallet found. Use a desktop device (laptop, PC). Please install MetaMask or another wallet.");
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      const network = await provider.getNetwork();
      if (network.chainId !== 8453) {
        // Switch to Base Mainnet
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: BASE_CHAIN_ID }],
        });
      }
      // Prompt user for amount
      let amount = prompt("How many SHB tokens do you want to buy? (1 SHB = 0.0012 ETH)");
      if (!amount) throw new Error("Purchase cancelled.");
      amount = parseFloat(amount);
      if (isNaN(amount) || amount <= 0) throw new Error("Invalid amount.");
      const value = ethers.parseEther((TOKEN_PRICE_ETH * amount).toFixed(6));
      const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, signer);
      const tx = await contract.buyTokens({ value });
      await tx.wait();
      setSuccess("Purchase successful! Check your wallet for SHB tokens.");
    } catch (err) {
      setError(err.message || "Transaction failed.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      onClick={handleBuy}
      disabled={loading}
      style={{
        display: "inline-block",
        background: loading ? "#e0e0e0" : "#fff",
        color: loading ? "#aaa" : "#b86fec",
        padding: "12px 32px",
        borderRadius: 10,
        textDecoration: "none",
        fontWeight: 700,
        fontSize: "1.2rem",
        marginTop: 12,
        boxShadow: "0 2px 8px rgba(184,111,236,0.10)",
        border: "none",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "background 0.2s, color 0.2s",
      }}
      onMouseOver={e => {
        if (!loading) {
          e.target.style.background = '#b86fec';
          e.target.style.color = '#fff';
        }
      }}
      onMouseOut={e => {
        if (!loading) {
          e.target.style.background = '#fff';
          e.target.style.color = '#b86fec';
        }
      }}
    >
      {loading ? "Processing..." : children || "Get Started"}
      {error && <div style={{ color: "#d32f2f", fontSize: "0.95rem", marginTop: 8 }}>{error}</div>}
      {success && <div style={{ color: "#388e3c", fontSize: "0.95rem", marginTop: 8 }}>{success}</div>}
    </button>
  );
}
